const ppcOrderArray = [
  "spend",
  "impressions",
  "impressionsTopRate",
  "impressionsAbsTopRate",
  "searchImpressionsShare",
  "views",
  "viewableImpressions",
  "clicks",
  "phoneCalls",
  "inStoreVisits",
  "cpsv",
  "earnedSubscribers",
  "earnedLikes",
  "earnedShares",
  "cpc",
  "cpv",
  "viewCtr",
  "ctr",
  "clickConversions",
  "viewConversions",
  "totalConversions",
  "cvr",
  "videoCvr",
  "clickRevenue",
  "viewRevenue",
  "shopifyRevenue",
  "totalRevenue",
  "clickCpa",
  "totalCpa",
  "clickRoas",
  "shopifyRoas",
  "totalRoas",
  "clickAov",
  "totalAov",
];

const seoOrderArray = [
  "traffic",
  "searchVisibility",
  "topThreeKeywords",
  "topThreeKeywordsPercentage",
  "topTenKeywords",
  "topTenKeywordsPercentage",
  "topTwentyKeywords",
  "topTwentyKeywordsPercentage",
  "averagePosition",
  "bounceRate",
  "conversions",
  "cvr",
  "revenue",
  "aov",
];
export default (service, array) => {
  if (service == "ppc") {
    array.sort((a, b) => ppcOrderArray.indexOf(a) - ppcOrderArray.indexOf(b));
    return array;
  } else if (service == "seo") {
    array.sort((a, b) => seoOrderArray.indexOf(a) - seoOrderArray.indexOf(b));
    return array;
  }
};
